import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const RecognizeAudienceProduct = z.object({
  provider: z.enum(Provider),
  productId: z.string().min(1),
});

export type RecognizeAudienceProduct = z.infer<typeof RecognizeAudienceProduct>;
